import { SelectOption } from "@/components/FormInputs/types";
import { i18n } from "@/i18n";

const TRANSLATION_PREFIX = "filters.fieldOptions";

type EnumFields = Record<string, Record<string, string | number>>;
const { t } = i18n;

interface enumReturn<T> {
  enumOptions: Record<keyof T, SelectOption[]>;
  missingTranslationKeys: string[];
}

export const getTranslatedOptionsFromEnums = <T>(
  enumFields: EnumFields,
): enumReturn<T> => {
  const missingTranslationKeys = new Set<string>();
  return {
    enumOptions: Object.entries(enumFields).reduce(
      (acc, [key, value]) => {
        const opts = Object.values(value).map((option) => {
          const translationKey = `${TRANSLATION_PREFIX}.${option}`;
          let label = t(translationKey);
          if (!i18n.exists(translationKey)) {
            label = `${option}`;
            missingTranslationKeys.add(translationKey);
          }
          return {
            label,
            value: `${option}`,
          };
        });
        acc[key as keyof T] = opts;
        return acc;
      },
      {} as Record<keyof T, SelectOption[]>,
    ),
    missingTranslationKeys: [...missingTranslationKeys],
  };
};
